var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 96,
    viewBox: "0 0 165 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.9999 2.83301C85.6077 2.83301 88.1093 3.86905 89.9531 5.71309L158.786 74.5465C162.626 78.3864 162.626 84.6129 158.786 88.4528C154.946 92.2927 148.72 92.2927 144.88 88.4528L82.9999 26.5727L21.1198 88.4528C17.2796 92.2927 11.0535 92.2927 7.21334 88.4528C3.37322 84.6129 3.37322 78.3864 7.21334 74.5465L76.0468 5.71309C77.8905 3.86905 80.3921 2.83301 82.9999 2.83301Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.c5fa945b84bde16990e0d14c331fe481.svg";
export { ForwardRef as ReactComponent };